import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as Actions from 'auth/store/actions/index';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles/index';
import { Button, Card, Grid, AppBar, Paper, CardContent, Divider, Typography } from '@material-ui/core';
import classNames from 'classnames';
import { TextFieldFormsy, FuseAnimate } from '@fuse';
import Formsy from 'formsy-react';

const styles = theme => ({
    root: {
        backgroundImage: "url(assets/images/backgrounds/header-bg.png)",
        backgroundSize: 'auto',
        height: '100vh'
    },
    paperWrapper: {
        paddingTop: '10vh',
        height: '20vh'
    },
    paperDiv: {
        height: '20vh'
    },
    cardDiv: {
        height: '40%'
    },
    paddingDiv: {
        paddingTop: '10vh'
    },
    instructionsDiv: {
        padding: '15px',
        fontSize: '18px',
    },
    sendButton: {
        paddingLeft: '15px',
        paddingRight: '15px'
    },
    textField: {
        paddingLeft: '15px',
        paddingRight: '15px',
        width: '100%'
    }
});


class PasswordReset extends Component {

    state = {   passwordSent: false  }

    constructor(props) {
        super(props);

        const token = this.props.match.params.token;
        this.props.checkTokenValid(token)
    }

    onSubmit = (model) => {
        this.props.resetPassword(model.password, this.props.tokenValid)
        this.setState({
            passwordSent: true
        })
    }
    render() {
        const { tokenValid, classes } = this.props
        if (!tokenValid) {
            return (
                <div className={classNames(classes.root)}>
                    <Grid container spacing={12}>
                        <Grid item xs={3}></Grid>
                        <Grid item xs={6}>
                            <div className={classNames(classes.paperDiv)}></div>
                            <Paper className={classNames(classes.paperDiv)}>
                                <div className="flex flex-col items-center justify-center pt-32">
                                    <h2>Your password reset request is invalid/expired</h2>
                                </div>
                            </Paper>
                        </Grid>
                    </Grid>
                </div>
            )
        }

        return (
            <div className={classNames(classes.root)}>
                <Grid container spacing={12}>
                    <Grid item xs={3}></Grid>
                    <Grid item xs={6}>
                        <div className={classNames(classes.paddingDiv)}>
                            <Card className={classNames(classes.cardDiv)}>
                                <AppBar position="static">
                                    <div className="p-16 pr-4 flex flex-row items-center justify-between">
                                        <Typography className="h1 pr-16" color="inherit">Reset Password</Typography>
                                    </div>
                                </AppBar>
                                <div className={classNames(classes.instructionsDiv)}><p>Please enter your email address. If an account with that address exists, we will send and email with a link to reset your password.</p></div>
                                <Formsy
                                    onValidSubmit={this.onSubmit}
                                >
                                    <div className={classNames(classes.instructionsDiv)}>
                                        <TextFieldFormsy
                                            className={classNames(classes.textField)}
                                            type="password"
                                            name="password"
                                            label="Password"
                                            validations="equalsField:password-confirm"
                                            validationErrors={{
                                                equalsField: 'Passwords do not match'
                                            }}
                                            required
                                        />
                                    </div>

                                    <div className={classNames(classes.sendButton)}>

                                        <TextFieldFormsy
                                            className={classNames(classes.textField)}
                                            type="password"
                                            name="password-confirm"
                                            label="Confirm Password"
                                            validations="equalsField:password"
                                            validationErrors={{
                                                equalsField: 'Passwords do not match'
                                            }}
                                            required
                                        />
                                    </div>
                                    <div className={classNames(classes.sendButton)}>
                                        <Button
                                            type="submit"
                                            variant="raised"
                                            color="primary"
                                            className="w-full mx-auto mt-16 normal-case"
                                            aria-label="Create an Account"
                                            disabled={this.state.passwordSent}
                                        >
                                            RESET PASSWORD
                                        </Button>
                                    </div>

                                </Formsy>
                                <div className={classNames(classes.instructionsDiv)}>{this.sentNotice(this.state.passwordSent)}</div>
                            </Card>
                        </div>
                    </Grid>
                </Grid>

            </div>
        )
    }

    sentNotice = prop => {
        return prop ?
            <div>
                <h2>Password successfully updated. Please login in <a href="/login">here</a></h2>
            </div> : null
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        checkTokenValid: Actions.checkTokenValid,
        resetPassword: Actions.resetPassword
    }, dispatch);
}

function mapStateToProps({ auth }) {
    return {
        tokenValid: auth.passwordreset.tokenValid
    }
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(PasswordReset)));


// WEBPACK FOOTER //
// src/main/content/auth/PasswordReset.js